import React, { Fragment, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router';
import axios from './axios';
import { useAuth } from '../context/AuthProvider';

interface IAxiosInterceptor {
  children: ReactNode;
}

export const AxiosInterceptor: React.FC<IAxiosInterceptor> = ({
  children,
}): JSX.Element => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          setAuth(null);
          navigate('/login'); // Redirect to login
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  return <Fragment>{children}</Fragment>;
};
